module.exports = __webpack_public_path__ + "media/smiles/happy_1-4ee2744e.svg";